//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.RefreshTokenMutation_ResponseAdapter
import com.wintermar.inspection.graphql.selections.RefreshTokenMutationSelections
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public class RefreshTokenMutation() : Mutation<RefreshTokenMutation.Data> {
  override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  override fun hashCode(): Int = this::class.hashCode()

  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    // This operation doesn't have any variable
  }

  override fun adapter(): Adapter<Data> = RefreshTokenMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = RefreshTokenMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(RefreshTokenMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val refreshToken: RefreshToken,
  ) : Mutation.Data

  public data class RefreshToken(
    public val loginToken: String,
    public val refreshToken: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "6e812eae59b6c8f27477cfa778d88e65eb254be953590ad297c507ba9df6d15b"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation refreshToken {
     *   refreshToken {
     *     loginToken
     *     refreshToken
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation refreshToken { refreshToken { loginToken refreshToken } }"

    public const val OPERATION_NAME: String = "refreshToken"
  }
}
